import React from 'react';
import { Observer } from 'mobx-react';
import { useStore } from '@store';
import { MainPageContainer, Navbar, StepWrapper } from 'components-core';

import * as services from './ErrorBoundary.services';

class ErrorBoundary extends React.Component {
  componentDidCatch(error) {
    const { name, message } = error;
    const { sharedStore } = this.props;
    sharedStore.addError({ name, message });
  }

  render() {
    const { children, sharedStore } = this.props;
    return (
      <Observer>
        {/* eslint-disable-next-line */}
        {() =>
          sharedStore.hasError ? (
            <MainPageContainer>
              <Navbar showBackButton={false} hideCloseIcon />
              <StepWrapper>{services.renderViewBasedOnError(sharedStore.errors[0])}</StepWrapper>
            </MainPageContainer>
          ) : (
            children
          )
        }
      </Observer>
    );
  }
}

const HookWrapper = ({ children }) => {
  const sharedStore = useStore('sharedStore');
  return <ErrorBoundary sharedStore={sharedStore}>{children}</ErrorBoundary>;
};

export default HookWrapper;
